import { Typography } from "@mui/material";
import TablaCarpetaV2 from "@/components/Tablas/TablaCarpetaV2";
import { TablaCarpetaProvider } from "@/components/Tablas/TablaCarpetaV2/logics/TablaCarritoProvider";
import FiltrosUserCarpetas from "./FiltrosUserCarpetas";
import { ViewAs } from "@/components/Tablas/TablaCarpetaV2/logics/useTablaCarritoV2";


const MisCarpetas = () => {


    return (<>

        <Typography sx={{
            textAlign: 'start',
            fontSize: '1.8rem',
            fontWeight: 'bold',
            color: 'primary.main',
            mb: 2
        }}>Carpetas</Typography>

        <TablaCarpetaProvider viewAs={ViewAs.USER}>
            <FiltrosUserCarpetas />
            <TablaCarpetaV2 />
        </TablaCarpetaProvider >

    </>);
}

export default MisCarpetas;

